import { Eye, Sparkles, Wrench } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { useUIMode } from "@/hooks/useUIMode";

interface Props {
  collapsed?: boolean;
}

/** Sprint UX-1: Toggle Simples/Avançado + atalho Modo Apresentação. */
export function UIModeToggle({ collapsed = false }: Props) {
  const { mode, toggleMode, presentation, togglePresentation } = useUIMode();

  if (collapsed) {
    return (
      <div className="flex flex-col items-center gap-1">
        <Tooltip>
          <TooltipTrigger asChild>
            <Button variant="ghost" size="icon" onClick={toggleMode} aria-label="Alternar modo">
              {mode === "simple" ? <Sparkles className="h-4 w-4" /> : <Wrench className="h-4 w-4" />}
            </Button>
          </TooltipTrigger>
          <TooltipContent side="right">{mode === "simple" ? "Modo Simples" : "Modo Avançado"}</TooltipContent>
        </Tooltip>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant={presentation ? "default" : "ghost"}
              size="icon"
              onClick={togglePresentation}
              aria-label="Modo apresentação"
            >
              <Eye className="h-4 w-4" />
            </Button>
          </TooltipTrigger>
          <TooltipContent side="right">Modo Apresentação</TooltipContent>
        </Tooltip>
      </div>
    );
  }

  return (
    <div className="px-3 py-2 space-y-2 border-b border-sidebar-border">
      <div className="flex items-center gap-1 rounded-md bg-muted p-0.5 text-xs">
        <button
          type="button"
          onClick={() => mode !== "simple" && toggleMode()}
          className={`flex-1 flex items-center justify-center gap-1 rounded-sm px-2 py-1 transition-colors ${
            mode === "simple" ? "bg-background text-foreground shadow-sm" : "text-muted-foreground hover:text-foreground"
          }`}
        >
          <Sparkles className="h-3 w-3" />
          Simples
        </button>
        <button
          type="button"
          onClick={() => mode !== "advanced" && toggleMode()}
          className={`flex-1 flex items-center justify-center gap-1 rounded-sm px-2 py-1 transition-colors ${
            mode === "advanced"
              ? "bg-background text-foreground shadow-sm"
              : "text-muted-foreground hover:text-foreground"
          }`}
        >
          <Wrench className="h-3 w-3" />
          Avançado
        </button>
      </div>
      <button
        type="button"
        onClick={togglePresentation}
        className={`w-full flex items-center justify-center gap-1.5 rounded-md px-2 py-1 text-xs transition-colors ${
          presentation
            ? "bg-primary/10 text-primary border border-primary/30"
            : "text-muted-foreground hover:text-foreground hover:bg-accent"
        }`}
      >
        <Eye className="h-3 w-3" />
        {presentation ? "Apresentação ativa" : "Modo Apresentação"}
      </button>
    </div>
  );
}
